import React from 'react';

import { Link } from '@eika/link';
import { Loader } from '@eika/loader';
import { RichIconTypes } from '@eika/rich-icon';

import ConfirmationScreen from '../../components/ConfirmationScreen/ConfirmationScreen';
import CreditCardApplicationScreen from '../../components/CreditCardApplicationScreen/CreditCardApplicationScreen';
import { useConfig } from '../../defaultConfig';
import { useCreditCards } from '../../hooks/useCreditCards';
import { useTranslation } from '../../translations';
import { kredittbankenTrackingIDs } from '../../utils/gtm/kredittbankenTrackingIds';

import './CreditCardConfirmationScreen.scss';

const CreditCardConfirmationScreen: React.FC = () => {
    const translated = useTranslation();
    const {
        links: { applyForCreditCard, applyForEikaEmployeeCard },
        featureToggles: { enableCreditCardConfirmationScreen, enableCreditCardEmployeeApplication },
    } = useConfig();
    const { data: creditCardAccounts, isLoading } = useCreditCards(enableCreditCardConfirmationScreen);

    if (!enableCreditCardConfirmationScreen) return <></>;

    if (isLoading) {
        return (
            <div className="sgw-center-loader">
                <Loader />
            </div>
        );
    }

    if (creditCardAccounts && creditCardAccounts.length > 0) {
        return <CreditCardApplicationScreen creditCards={creditCardAccounts} />;
    }

    return (
        <ConfirmationScreen
            title={translated.confirmationScreen.creditCardTitle}
            icon={RichIconTypes.KREDITTKORT}
            showTextTitle={false}
            link={
                <div className="credit-card-confirmation-screen__link-container">
                    <Link
                        href={applyForCreditCard?.url}
                        linkType="button-positive"
                        data-track-id={kredittbankenTrackingIDs.applyForCreditCard}
                        data-track-linkname={translated.confirmationScreen.creditCardLinkText}
                    >
                        {translated.confirmationScreen.creditCardLinkText}
                    </Link>
                    {enableCreditCardEmployeeApplication && (
                        <Link
                            href={applyForEikaEmployeeCard?.url}
                            linkType="button-positive"
                            data-track-id={kredittbankenTrackingIDs.applyForCreditCard}
                            data-track-linkname={translated.confirmationScreen.eikaEmployeeCardLinkText}
                        >
                            {translated.confirmationScreen.eikaEmployeeCardLinkText}
                        </Link>
                    )}
                </div>
            }
        />
    );
};

export default CreditCardConfirmationScreen;
